.root {
  display: flex;
  min-height: 100%;
  background-color: var(--color-gray);
}

.root[data-viewer]:not(:has([data-error-fallback])) {
  height: 100%;
  min-height: 30em;
}

.main {
  flex: 4 1 0%;
  min-width: 0;
  display: flex;
  padding: 1rem 0.75rem 1rem 0;
}

.mainInner {
  flex: 1 1 0%;
  min-width: 0;
  display: flex;
  background-color: white;
  border-radius: 1rem;
  overflow: hidden;
  z-index: 0; /* stacking context for main content */
}

.mainInner > :global(.reflex-container) {
  font-size: 1em; /* let viewer adapt to myHDF5 font size */
}
